import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.weekly.online,
    (task) => {
        return {
            task
        }
    }
)